module.exports = __webpack_public_path__ + "img/layers.cef952e3.png";